import React from "react";
import { Route, Routes } from "react-router-dom";

import MainLayout from "../../layouts/MainLayout";

import AcceptTerms from "./pages/AcceptTerms/AcceptTerms";
import ChooseTheme from "./pages/ChooseTheme/ChooseTheme";
import CreateGiftTableStep1 from "./pages/CreateGiftTable/CreateGiftTableStep1";
import CreateGiftTableStep2 from "./pages/CreateGiftTable/CreateGiftTableStep2";
import CreateGiftTableStep3 from "./pages/CreateGiftTable/CreateGiftTableStep3";
import CreateGiftTableStep4 from "./pages/CreateGiftTable/CreateGiftTableStep4";
import GiftTableSummary from "./pages/GiftTableSummary/GiftTableSummary";
import Success from "./pages/Success/Success";
import SignIn from "./pages/SignIn/SignIn";
import Signup from "./pages/Signup/Signup";
import InitPage from "./pages/InitPage";
import PasswordRecovery from "./pages/PasswordRecovery";
import PasswordReset from "./pages/PasswordReset";

const RegistrationRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/init" element={<InitPage />} />
      <Route
        path="/signup"
        element={
          <MainLayout>
            <Signup />
          </MainLayout>
        }
      />
      <Route
        path="/signin"
        element={
          <MainLayout>
            <SignIn />
          </MainLayout>
        }
      />
      <Route
        path="/password-recovery"
        element={
          <MainLayout>
            <PasswordRecovery />
          </MainLayout>
        }
      />
      <Route
        path="/password-reset"
        element={
          <MainLayout>
            <PasswordReset />
          </MainLayout>
        }
      />

      <Route
        path="/accept-terms"
        element={
          <MainLayout>
            <AcceptTerms />
          </MainLayout>
        }
      />
      <Route
        path="/create-gift-table/step1"
        element={
          <MainLayout>
            <CreateGiftTableStep1 />
          </MainLayout>
        }
      />
      <Route
        path="/create-gift-table/step2"
        element={
          <MainLayout>
            <CreateGiftTableStep2 />
          </MainLayout>
        }
      />
      <Route
        path="/create-gift-table/step3"
        element={
          <MainLayout>
            <CreateGiftTableStep3 />
          </MainLayout>
        }
      />
      <Route
        path="/create-gift-table/step4"
        element={
          <MainLayout>
            <CreateGiftTableStep4 />
          </MainLayout>
        }
      />
      <Route
        path="/create-gift-table/choose-theme"
        element={
          <MainLayout>
            <ChooseTheme />
          </MainLayout>
        }
      />
      <Route
        path="/create-gift-table/summary"
        element={
          <MainLayout>
            <GiftTableSummary />
          </MainLayout>
        }
      />
      <Route
        path="/create-gift-table/success"
        element={
          <MainLayout>
            <Success />
          </MainLayout>
        }
      />
    </Routes>
  );
};

export default RegistrationRouter;
